import { useEffect, useState } from 'react';

type ConsentState = 'accepted' | 'rejected' | null;

const CONSENT_KEY = 'noteon_cookie_consent';

export function useCookieConsent(isEU: boolean | null) {
  const [consent, setConsent] = useState<ConsentState>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    try {
      const stored = window.localStorage.getItem(CONSENT_KEY) as ConsentState | null;
      if (stored === 'accepted' || stored === 'rejected') {
        setConsent(stored);
        return;
      }

      if (isEU === false) {
        setConsent('accepted');
        window.localStorage.setItem(CONSENT_KEY, 'accepted');
      }
    } catch {
      // Ignore storage errors
    }
  }, [isEU]);

  const accept = () => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(CONSENT_KEY, 'accepted');
      setConsent('accepted');
    } catch {
      // Ignore storage errors
    }
  };

  const reject = () => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(CONSENT_KEY, 'rejected');
      setConsent('rejected');
    } catch {
      // Ignore storage errors
    }
  };

  const shouldShow = isEU === true && consent === null;
  const analyticsAllowed = isEU === null ? false : isEU ? consent === 'accepted' : consent !== 'rejected';

  return {
    consent,
    shouldShow,
    analyticsAllowed,
    accept,
    reject,
  };
}
